<template>
  <div class="d-flex align-items-center justify-content-between mb-4">
    <div>
      <div class="d-flex align-items-center">
        <button type="button" class="btn btn-outline-secondary rounded-0 me-3" @click="router.back()"><font-awesome-icon icon="chevron-left" /> Zurück</button>
        <h1 class="mb-0">{{ unternehmen?.titel }}</h1>
      </div>

      <div class="my-auto">
        <span class="text-muted me-2">{{ unternehmen?.realm }}</span>
        <font-awesome-icon v-if="unternehmen.hasIdpRealm" icon="address-card" />

        <button v-else type="button" class="btn btn-sm btn-outline-secondary" @click="createUnternehmenRealm(unternehmen.id)">
          <div v-if="commonStore.status.createUnternehmenRealmLoading" class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>

          <span v-else><font-awesome-icon icon="plus" /> Realm erstellen</span>
        </button>
      </div>
    </div>

    <div v-if="unternehmen?.id != 0" class="d-flex align-items-center">
      <EditUnternehmenModal :unternehmen="unternehmen" :index="0" :buttonStyle="2" @delete-unternehmen="deleteUnternehmen" />
    </div>
  </div>

  <UnternehmenUsersSection :unternehmen="unternehmen" />

  <div class="mb-3">
    <h3>Archiv Zugangsdaten</h3>
    <p><strong>Archiv API URL:</strong> {{ unternehmen?.archivApiUrl }}</p>
    <p><strong>Archiv API Key:</strong> {{ unternehmen?.archivApiKey }}</p>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted, PropType, watch } from 'vue';
  import { useRouter } from 'vue-router';

  import EditUnternehmenModal from '@/components/Unternehmen/EditUnternehmenModal.vue';
  import UnternehmenUsersSection from '@/components/Unternehmen/users/UnternehmenUsersSection.vue';

  import { useUnternehmenStore } from '@/stores/unternehmenStore';
  import { Unternehmen } from '@/models/UnternehmenModels';
  import { useCommonStore } from '@/stores/commonStore';
  //#endregion

  const { id } = defineProps({
    id: {
      type: Number as PropType<number>,
      required: true,
    },
  });

  const router = useRouter();

  const commonStore = useCommonStore();
  const unternehmenStore = useUnternehmenStore();
  const unternehmen = computed(() => unternehmenStore.unternehmen.find((u: Unternehmen) => u.id === id));

  function deleteUnternehmen() {
    unternehmenStore.deleteUnternehmen(unternehmen.value.id).then(() => {
      router.push({ name: 'Unternehmen' });
    });
  }

  watch(
    () => id,
    async () => {
      if (id) {
        console.log('Do Something with id:', id);
      }
    }
  );

  async function createUnternehmenRealm(id: number) {
    await unternehmenStore.createUnternehmenRealm(id);
  }

  onMounted(async () => {
    if (unternehmenStore.unternehmen.length === 0) {
      await unternehmenStore.getUnternehmen();
    }

    if (unternehmen.value.hasIdpRealm == undefined || !unternehmen.value.hasIdpRealm) {
      await unternehmenStore.unternehmenHasRealm(unternehmen.value.realm);
    }
  });
</script>
